<template>
  <div>
  <el-dialog title="备注信息" :visible.sync="dialogVisible" @close='dialogFormVisible'  :close-on-click-modal="false"
    :close-on-press-escape="false">
       
        <el-form size="small" :model="form">
           
          <el-form-item label="备注" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="seller_remark" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label="" :label-width="formLabelWidth">
            <el-button type="primary" @click="addRemark" :loading="loading">提交</el-button>
          </el-form-item>
        
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import OrderApi from '@/api/order.js';
  export default {
    components: {
    },
    data() {
      return {
        tableData:[],
        /*左边长度*/
        formLabelWidth: '80px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        curPage: 1,
        pageSize: 10,
        seller_remark: '',
        reverse: false,
      };
    },
    props: ['open_remark', 'form'],
    created() {
      this.dialogVisible = this.open_remark;
      console.log(this.dialogVisible)
      this.seller_remark = this.form.seller_remark;
    },
    methods: {
      /*修改用户*/
      addRemark() {
        let self = this;
        self.loading = true;
        let params = {
          order_id:self.form.order_id,
          seller_remark:self.seller_remark,
        };
        if(!params.seller_remark){
          self.$message({
                message: '请填写内容给',
                type: 'error'
              });
              self.loading = false;
              return;
        }
        OrderApi.remarkAdd(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.dialogFormVisible(true)
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/Remark.vue